/* import __COLOCATED_TEMPLATE__ from './query-selector.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();